module.exports = __webpack_public_path__ + "static/media/verticalRectangle_blue.17ffb935.svg";